skrilla.controller('perClaimDepositModalCtrl', function ($scope, cacheService, modalService, searchService, validationService, currencyService) {
    let userId = cacheService.getObjectOrElse("perClaimUserId", modalService.dismissAll)
    $scope.validate = {}
    $scope.request = {};

    $scope.create = function(){
        if(validate()){
            let request = {...$scope.request}
            request.upTo  = currencyService.multiply(request.upTo, 'AUD')
            modalService.confirm("Are you sure you'd like to create this deposit bonus", ()=>{
                searchService.put(`users/${userId}/promotion/perClaimDepositBonus`, request, "Success!").then(modalService.dismissAll)
            })
        }
    }

    function validate() {
        let inputs = [
            validationService.buildFieldValidationObj("reason", validationService.isNotEmpty($scope.request.reason), "Please provide a reason"),
            validationService.buildFieldValidationObj("upTo", validationService.isNumberGreaterThanZero($scope.request.upTo), "Please provide a valid up to amount"),
            validationService.buildFieldValidationObj("matchPercentage", validationService.isNumberGreaterThanZero($scope.request.matchPercentage), "Please provide a valid match percentage"),
            validationService.buildFieldValidationObj("expiresAt",
                $scope.request.expiresAt === undefined || $scope.request.expiresAt === null ||
                (validationService.isDate($scope.request.expiresAt) && $scope.request.expiresAt > new Date()),
            "Expires at must be in the future."),
        ]

        return validationService.validateForm(inputs, $scope.validate)
    }

});